export default {
	MIN_VOLUME: 0,
	MAX_VOLUME: 1,
}
